import React, { useEffect, useState, useContext } from 'react'
import { CCard, CFormInput, CFormSwitch, CCol, CFormText, CButton } from '@coreui/react'
import Editor from 'src/components/Editor/Editor'
import { updateStaticPages } from 'src/Redux/Actions/templateAction'
import { useDispatch } from 'react-redux'
import { checkPermissions } from 'src/views/utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { dispatchAlert } from 'src/Redux/Actions/authAction'

const StaticDataPage = ({ data }) => {
  const dispatch = useDispatch()
  const [pageName, setPageName] = useState(data.title)
  const [htmlData, setHtmlData] = useState(data.content)
  const [visibleStatus, setVisibleStatus] = useState(data.visible)

  const { userSessionObj } = useContext(GlobalContext)

  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.WEBSITE.UPDATE,
  )

  useEffect(() => {
    setPageName(data.title)
    setHtmlData(data.content)
    setVisibleStatus(data.visible)
  }, [data])

  const handleSave = async () => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    let payload = {
      title: pageName,
      visible_on_website: visibleStatus,
      content: htmlData,
    }
    let updateRes = await dispatch(updateStaticPages(payload, data.id))

    if (updateRes?.success) {
      dispatch({ type: 'REFRESH_DATA' })
      dispatch(dispatchAlert('success', `Success`, `${updateRes.message}`, true))
    }
  }

  return (
    <div>
      <CCard style={{ height: '37rem' }}>
        <div className="mt-5 mx-5 h-100">
          <div className="d-flex justify-content-between">
            <CCol xs="6">
              <CFormInput
                className="w-75"
                size="sm"
                value={pageName}
                onChange={(e) => setPageName(e.target.value)}
              />
            </CCol>
            <CCol className="d-flex justify-content-center">
              <CFormSwitch
                label={visibleStatus ? 'Enabled on your website.' : 'Disabled on your website.'}
                checked={visibleStatus}
                valid={visibleStatus}
                onChange={(e) => setVisibleStatus(e.target.checked)}
                size="lg"
              />
            </CCol>
          </div>
          <div className="mt-5 d-flex align-items-center">
            <CCol>
              <Editor value={htmlData} handleChange={setHtmlData} />
            </CCol>
            <CCol xs="4" className="d-flex">
              <CFormText className="px-5">{data.description}</CFormText>
            </CCol>
          </div>
          <div className="d-flex mt-4 flex-row-reverse mb-3">
            <CButton
              color="info"
              className="text-white mx-5"
              onClick={handleSave}
              disabled={!updateAllowed}
            >
              Save
            </CButton>
          </div>
        </div>
      </CCard>
    </div>
  )
}

export default StaticDataPage
